import React, { useState, useCallback, useEffect, useRef } from 'react';
import { GETDESTINATION, GETOWNERCODE } from '../../../../Utils/conts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row, Col, Modal, Dropdown, Badge, Button, FormGroup } from 'react-bootstrap';
import { faPlus, faXmark, faUpload, faPaperclip, faDownload, faCircleXmark, faLink, faCircleCheck, faChevronDown, faGear, faUser } from '@fortawesome/free-solid-svg-icons';
import ImageUpload from '../../../../Components/common/ImageUpload';
import ActivityComments from '../../../../Components/common/ActivityComments';
import Edit from "../../../../assets/images/pen.png";
import pen from "../../../../assets/images/pen.png";
import Info_edit from "../../../../assets/images/info.png";
import Trash from "../../../../assets/images/trash.png";
import View from "../../../../assets/images/view.png";
import Docmnt from '../../../../assets/images/google-docs.png';
import Export from "../../../../assets/images/export.svg";
import { Tab, Tabs } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import XLSFILE from '../../../../assets/demo_template.xls'
import Accordion from 'react-bootstrap/Accordion';
import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import Select from 'react-select';
import { Link, useHistory } from 'react-router-dom';
import handlingCodes  from "../../../../assets/special_handling_codes.json"   
import CreatableSelect from 'react-select/creatable';
import Arcv from "../../../../assets/images/archive.svg";
import Activ from "../../../../assets/images/active.svg"; 
import Collapse from 'react-bootstrap/Collapse'; 
import { jqxCookieCall } from '../../../../Components/common/CommonFunctions.js';

const Expected = () => {

  const isMounted = useRef(false);
  const history = useHistory();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [damageType, setDamageType] = useState([]);
  const [totalRows, setTotalRows] = useState();
  const [totalRowsR, setTotalRowsR] = useState(0);
  const [filterApplied, setFilterApplied] = useState(false);
  const [activeTab, setActiveTab] = useState('active');
  const [resetFilter, setResetFilter] = useState(false);
  const [getDestination, setGetDestination] = useState([]);
  const [shipperOptions, setShipperOptions] = useState([]);
  const [consigneeOptions, setConsigneeOptions] = useState([]);
  const [getOwnerCodes, setGetOwnerCode] = useState([]);
  const [modalContent, setModalContent] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalRadioValue, setModalRadioValue] = useState('');
  const handleModalClose = () => { setShowModal(false); setModalRadioValue('') };
  const [fileName, setFileName] = useState('');
  const [getPackaging, setGetPackaging] = useState([]);
  const [switchData, setSwitchData] = useState();
  const [locationOptions, setLocationOptions] = useState();
  const [shipperDefaults, setShipperDefaults] = useState([]);
  const [consigneeDefaults, setConsigneeDefaults] = useState([]);
  const handlingOptions = handlingCodes.map(item => ({
  value: item.code,
  label: `${item.code} - ${item.description}`
}));
  const [customerModal, setCustomerModal] = useState(false);
  const [customerModalType, setCustomerModalType] = useState('shipper'); // 'shipper' or 'consignee'
  const [customerData, setCustomerData] = useState({ agent_or_customer: 'C' })
  const acceptanceWarehouseInhandlerOptions = [
    { label: '--', value: '-' },
    { label: 'Transfer', value: 'Transfer' },
    { label: 'NCTS', value: 'NCTS' },
    { label: 'IM4', value: 'IM4' },

  ];

  const gridRef = useRef(null);
  const gridRefs = {
    active: useRef(null),
    mismatch: useRef(null),
    archive: useRef(null),
  };
  const [gridData, setGridData] = useState({
    active: [],
    mismatch: [],
    archive: [],

  });
  const initialFormData = {
      mawb: "",
      expected_pieces: "",
      pcs_type: "Colli",
      expected_weight: "",
      volume: "",
      special_handling_code: "",
      shipper: "",
      consignee: "",
      flight_details: [
        {
          flight_code: "",
          flight_number: "",
          flight_date: "",
          eta: "",
          origin: "",
          destination: ""
        }
      ]
    };


  const [formData, setFormData] = useState({ ...initialFormData });

  const fetchDestination = async () => {
    try {

      const res = await withRFSToken.post(GETDESTINATION, {})
        .then(function (res) {
          const innerData = res.data.response_data;
          const transformedData = innerData ? innerData.map(item => ({
            value: item.port_code,
            label: item.port_code,
            address: item.address,
            station_id: item.station_id
          })) : [];
          setGetDestination(transformedData);
          //   console.log("trans",transformedData);
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetchShipperConsignee = async (tab) => {
  try {
    const res = await withRFSToken.post("address-book/customer-name-type", { tab: tab });
    const innerData = res.data.Rows;
    const transformedData = innerData ? innerData.map(item => ({
      value: item.id,
      label: item.name,
    })) : [];
    if (tab == "Shipper") {
      setShipperOptions(transformedData);
    } else if (tab == "Consignee") {
      setConsigneeOptions(transformedData);
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
};
  const fetchOwnerCode = async () => {
    try {
      const res = await withRFSToken.post(GETOWNERCODE, {})
        .then(function (res) {
          const innerData = res.data.response_data;
          const transformedData = innerData ? innerData.map(item => ({
            value: item.IATA,
            label: item.IATA,
            airline_name: item.airline_name
          })) : [];
          setGetOwnerCode(transformedData);
        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
const CustomerOptions = [
    { label: 'Forwarder', value: 'F' },
    { label: 'Shipper', value: 'S' },
    { label: 'Consignee', value: 'C' },
];
const CustomerOrAgent = [
  { label: 'Customer', value: 'C' },
  { label: 'Agent', value: 'A' },
];
  const fetchLocation = async () => {
    try {
      const res = await withRFSToken.get("forwarder-location/list?filtervalue0=Inactive");
      const innerData = res.data?.Rows;
      const transformedData = innerData ? innerData.map(item => ({
        value: item.location,
        label: item.location,
      })) : [];
      setLocationOptions(transformedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const fetchRule = async () => {
    try {
      const res = await withRFSToken.get('shipment/get-general-settings', {});
      // .then(function (res) {
      if (res.data.response_code === 200) {
        const innerData = res.data.response_data
        const reData = innerData[0]?.status == 1 ? true : false;
        // const health_ins_stat = innerData[1]?.status == 
        setSwitchData(reData);
      } else {
        toast.error(res.data.response_msg);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const fetchPackaging = async () => {
    try {

      const res = await withRFSToken.post('shipment/type-of-packaging', {})
        .then(function (res) {
          const innerData = res.data.response_data;
          const transformedData = innerData ? innerData.map(item => ({
            value: item.id,
            label: item.description,
          })) : [];
          setGetPackaging(transformedData);
          //   console.log("trans",transformedData);
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
   const fetchOpenTabTotalRows = useCallback(async () => {
      try {
        const res = await withRFSToken.get("shipment/get-import-shipment-information?type=mismatch", {params: {pagenum: 0,pagesize: 100,recordstartindex: 0,recordendindex: 1,filterscount: 0},});
        const parsedTotal = Number(res?.data?.TotalRows);
        setTotalRows(parsedTotal);
      } catch (error) {
        console.error("Failed to fetch Open tab total rows:", error);
      }
    }, []);

    
    useEffect(() => {
      if (isMounted.current) return;
      setIsLoading(false);
      setGridData({ Active: {} });
      fetchDestination();
      fetchShipperConsignee('Shipper');
      fetchShipperConsignee('Consignee');
      fetchOwnerCode();
      fetchLocation();
      fetchPackaging();
      fetchRule();
      fetchOpenTabTotalRows();
      isMounted.current = true;
    }, []);
    
    // useEffect(() => {
    //     if (activeTab === "active") {
    //       fetchOpenTabTotalRows();
    //     }
    //   }, [activeTab, fetchOpenTabTotalRows]);

  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedRowDetails, setSelectedRowDetails] = useState(null);
  const [gridSelect, setGridSelect] = useState([]);


  const handleTabChange = async (tab) => {
    setActiveTab(tab);
    // const tabType = () => {tab == 'Active' ? 'A' : 'R'}
    setFilterApplied(false);
    if (selectedRowData) {
      setSelectedRowData(null)
    }
    setGridSelect([]);
    setIsLoading(true);
    if (tab == 'active') {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ Active: {} });
      }, 1);
    } else {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ Archived: {} });
      }, 1);
    }
  }

  const [mawbModal, setMawbModal] = useState(false);
  const [modalFor, setModalFor] = useState('');

  const closeModal = () => {
    setMawbModal(false);
    setFormData(JSON.parse(JSON.stringify(initialFormData)));
    setHouseAwbInput('');
    setSavedHouseAwbs([]);
    setHawbShow(true);
  }
  const [modalData, setModalData] = useState({})
  const handleDropdownItemClick = (pos, action, isProgrammatic = false, selectedRowData = null) => {
    const handleTopAction = () => {
      if (action == 'B') {
        const dataToUse = isProgrammatic && selectedRowData ? selectedRowData : gridSelect[0];
        if (!isProgrammatic && gridSelect.length <= 0) {
          toast.error('Please select grid data before sending to instock');
        } else if (!isProgrammatic && gridSelect.length > 1) {
          toast.error('Only select 1 mawb to move to instock');
        } else if (isProgrammatic && !selectedRowData) {
          toast.error('No data found for the selected row');
        } else {
          setShipmentGroups(dataToUse.hawbs.map(item => ({ ...item, piecesConfirm: "NO", temperature_type: 'C', warehouse_in: new Date().toLocaleString('sv-SE', { hour12: false }).replace(' ', 'T').slice(0, 16), warehouse_in_doc_type: 'Transfer' })));
          setModalData(dataToUse);
          setModalFor(action);
          setMawbModal(true);
          localStorage.removeItem('link_mawb');
        }
      } else {
        setShipmentGroups([
          { packaging: '', e_pcs: '', e_weight: '', files: [] }
        ]);
        setModalFor(action);
        setMawbModal(true);
        setHawbShow(false);
      }
    }

    if (pos === 'D') {
      // handleDetailsAction();
    } else if (pos === 'T') {
      handleTopAction();
    }
  }

  //modal functionality for noa rcf eta ata 
  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };
  const [modalOpen, setModalOpen] = useState(false)
  const [confirmModal, setConfirmModal] = useState(false)
  const [isContinue, setIsContinue] = useState(false);
  const handleSetFunction = (pos, id, date) => {
    setModalOpen(true);
    const position = pos === 'eta' ? 'ETA' : pos === 'rcf' ? 'RCF' : pos === 'ata' ? 'ATA' : pos === 'noa' ? 'NOA' : pos === 'dlv' ? 'DLV' : '';
    setModalData({ updateFlag: position, id: id, set_date: date || getCurrentDateTime() })
  }
  const modalClose = () => {
    setModalOpen(false);
    setModalData({})
  }
  const confirmModalClose = () => {
    setConfirmModal(false);
    // setModalData({})
  }
  const modalInputChange = (name, value) => {
    setModalData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  }
  const updateDate = async () => {
    const payload = {
      import_shipment_record_id: modalData.id,
      [modalData.updateFlag.toLowerCase()]: modalData.set_date
    };
    try {
      const res = await withRFSToken.post('shipment/update-shipment-record-fields', payload)
        .then(function (res) {
          const innerData = res.data.response_data;
          if (res.data.response_code === 200) {
            toast.success(res.data.response_msg);
            modalClose();
            window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
            // setTimeout(() => {
            //   setIsLoading(false);
            //   window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata')
            // }, 1);
          } else {
            toast.error(res.data.response_msg);
          }
        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  // end of modal functionality for noa rcf eta ata 


  // useEffect(() => {
  //   const applyFilter = localStorage.getItem('applyFilter');
  //   if (applyFilter && gridRefs[activeTab].current) {
  //     // window.$(gridRefs[activeTab].current).jqxGrid("clearfilters");
  //     // window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");
  //     Object.keys(applyFilter).forEach((field) => {
  //       const filterValue = applyFilter[field];
  //       console.log('filterValue', filterValue);

  //       if (filterValue !== null && filterValue !== undefined) {
  //         const filterGroup = new window.$.jqx.filter();
  //         const filterCondition = "CONTAINS"; // Adjust the condition as needed
  //         const filter = filterGroup.createfilter("stringfilter", filterValue, filterCondition);
  //         console.log("🚀 ~ Object.keys ~ filter:", filter)
  //         filterGroup.addfilter(1, filter);
  //         window.$(gridRefs[activeTab].current).jqxGrid("addfilter", field, filterGroup);
  //       }
  //     });
  //     window.$(gridRefs[activeTab].current).jqxGrid("applyfilters");
  //     // setApplyFilter(false); // Reset the applyFilter flag
  //   }
  // }, []);

  let checkUlds = [];
  let filterForCheck = false;
  useEffect(() => {
    if (gridRefs[activeTab]?.current) {
      // if (gridData[activeTab]) {
      // var token = "Bearer " + localStorage.RFS;
      jqxCookieCall()
      const source = {
        datatype: 'json',
        datafields: [
          { name: 'id', type: 'string' },
          // { name: 'console_no', type: 'string' },
          // { name: 'flight_date', type: 'date' },
          // { name: 'origin_country', type: 'string' },
          // { name: 'origin_city', type: 'string' },
          // { name: 'destination_country', type: 'string' },
          // { name: 'destination_city', type: 'string' },
          // { name: 'total_pieces', type: 'string' },
          // { name: 'total_weight', type: 'string' },
          // { name: 'c_w', type: 'string' },
          // { name: 'total_volume', type: 'string' },

          { name: 'mawb', type: 'string' },
          { name: 'import_shipment_record_id', type: 'string' },
          { name: 'airport_origin', type: 'string' },
          { name: 'consignee_name', type: 'string' },
          { name: 'total_pcs', type: 'string' },
          { name: 'pcs_type', type: 'string' },
          { name: 'flight', type: 'string' },
          { name: 'total_weight', type: 'string' },
          //{ name: 'total_volume', type: 'string' },
          { name: 'status', type: 'string' },
          { name: 'hawbs', type: 'array' },
          { name: 'eta', type: 'string' },
          { name: 'ata', type: 'string' },
          { name: 'rcf', type: 'string' },
          { name: 'noa', type: 'string' },
          { name: 'handler', type: 'string' },
          { name: 'acp_pcs', type: 'string' },
          { name: 'dlv', type: 'string' },
          { name: 'customer_name', type: 'string' },
          { name: 'shipper', type: 'string' },
        ],
        id: `${activeTab}-`,
        url: `${process.env.REACT_APP_RFS_URL}shipment/get-import-shipment-information?type=${activeTab}`,
        // beforeSend: function (jqXHR) {
        //   jqXHR.setRequestHeader('Authorization', token);
        // },
        // localdata: gridData[activeTab],
        pagesize: 50,
        filter: function (allfilters) {
          if (allfilters.length > 0) {
            setFilterApplied(true);
            filterForCheck = true;
          } else {
            setFilterApplied(false);
            filterForCheck = false;
          }
          window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
          window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");


          // setTimeout(() => {
          //     const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');

          //     console.log("rows", rows);
          //     (checkUlds).forEach(uldNumber => {
          //         console.log(checkUlds);
          //         rows.forEach((element, index) => {
          //             if (element.uld_number == uldNumber) {
          //                 window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
          //             }
          //         });
          //     });
          // }, 4000);
        },
        beforeprocessing: function (data) {
          source.totalrecords = data.TotalRows;
          // setTotalRows({ totalUlds: data.activeCount });
          // setTotalRowsR({ totalUlds: data.archiveCount });
        },
        sort: function () {
          window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
        },
        root: "Rows",
        cache: false,
      };
      const dataAdapter = new window.$.jqx.dataAdapter(source);
      const columns = [
        // {
        //   text: 'Actions',
        //   cellsrenderer: function () {
        //     // return '<div class="grid_actions"><img src="' + View + '" class="row_view" /> <img src="' + Trash + '" class="row_trash" /></div>';
        //     return '<div class="grid_actions"><img src="' + View + '" class="row_view" /></div>';
        //   },
        //   width: '4%', filterable: false,
        // },
        { text: 'MAWB', filtertype: 'input', datafield: 'mawb', width: '6%', cellclassname: '', },
        { text: 'Origin', filtertype: 'input', datafield: 'airport_origin', width: '3%', cellclassname: '', },
        //{ text: 'Consignee', filtertype: 'textbox', datafield: 'consignee_name', width: '12%', cellclassname: '', },
        { text: 'TTL Pcs', filtertype: 'input', datafield: 'total_pcs', width: '4%', cellclassname: '', },
        { text: 'Pcs Type', filtertype: 'input', datafield: 'pcs_type', width: '4%', cellclassname: '', },
        { text: 'TTL Weight', filtertype: 'input', datafield: 'total_weight', width: '5%', cellclassname: '', },
        { text: 'Flight No.', filtertype: 'input', datafield: 'flight', width: '5%', cellclassname: '', },
        // { text: 'Acp Pcs', filtertype: 'textbox', datafield: 'acp_pcs', width: '5%', cellclassname: '', },
        {
          text: 'Acp Pcs', filterable : false, datafield: 'acp_pcs', width: '5%',
          cellclassname: (row, column, value) => {
            const [num, dem] = (value || '').split('/').map(Number);
            if (isNaN(num) || isNaN(dem)) return 'awb_grey';
            return num === dem ? 'awb_green' : 'awb_orange';
          },
        },
        //{ text: 'Total Volume', filtertype: 'textbox', datafield: 'total_volume', width: '6%', cellclassname: '', },
        // { text: 'ETA', filtertype: 'textbox', datafield: 'eta', width: '10%', cellclassname: '', },
        { text: 'Handler', filtertype: 'input', datafield: 'handler', width: '5%', cellclassname: '', },
        { text: 'Shipper', filtertype: 'input', datafield: 'shipper', width: '5%', cellclassname: '', },
        { text: 'Customer', filtertype: 'input', datafield: 'customer_name', width: '7%', cellclassname: '', },
        {
          text: 'ETA', datafield: 'eta', width: '9%', filtertype: 'range', filtermode: 'range',
          cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, data) {
            if (cellValue) {
              defaultHtml = '<div style="margin-top: 12px; margin-left:5px">' + cellValue + '<span class="screen" style="margin-left:5px"><img src="' + Info_edit + '" class="" /></span></div>';
            } else {
              defaultHtml = '<div class="set_fn screen"><span class=""><img src="' + pen + '" class="" /> Set</span></div>';
            }
            return (
              defaultHtml
            );
          },
        },
        // { text: 'ATA', filtertype: 'textbox', datafield: 'ata', width: '10%', cellclassname: '', },
        {
          text: 'ATA', datafield: 'ata', width: '9%', filtertype: 'range', filtermode: 'range',
          cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, data) {
            if (cellValue) {
              defaultHtml = '<div style="margin-top: 12px; margin-left:5px">' + cellValue + '<span class="screen" style="margin-left:5px"><img src="' + Info_edit + '" class="" /></span></div>';
            } else {
              defaultHtml = '<div class="set_fn screen"><span class=""><img src="' + pen + '" class="" /> Set</span></div>';
            }
            return (
              defaultHtml
            );
          },
        },
        //  { text: 'RCF', filtertype: 'textbox', datafield: 'rcf', width: '8%', cellclassname: '', },
        {
          text: 'RCF', datafield: 'rcf', width: '9%', filtertype: 'range', filtermode: 'range',
          cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, data) {
            if (cellValue) {
              defaultHtml = '<div style="margin-top: 12px; margin-left:5px">' + cellValue + '<span class="screen" style="margin-left:5px"><img src="' + Info_edit + '" class="" /></span></div>';
            } else {
              defaultHtml = '<div class="set_fn screen"><span class=""><img src="' + pen + '" class="" /> Set</span></div>';
            }
            return (
              defaultHtml
            );
          },
        },
        // { text: 'NOA', filtertype: 'textbox', datafield: 'noa', width: '10%', cellclassname: '', },
        {
          text: 'NOA', datafield: 'noa', width: '9%', filtertype: 'range', filtermode: 'range',
          cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, data) {
            if (cellValue) {
              defaultHtml = '<div style="margin-top: 12px; margin-left:5px">' + cellValue + '<span class="screen" style="margin-left:5px"><img src="' + Info_edit + '" class="" /></span></div>';
            } else {
              defaultHtml = '<div class="set_fn screen"><span class=""><img src="' + pen + '" class="" /> Set</span></div>';
            }
            return (
              defaultHtml
            );
          },
        },
        {
          text: 'DLV', datafield: 'dlv', width: '9%', filtertype: 'range', filtermode: 'range',
          cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, data) {
            if (cellValue) {
              defaultHtml = '<div style="margin-top: 12px; margin-left:5px">' + cellValue + '<span class="screen" style="margin-left:5px"><img src="' + Info_edit + '" class="" /></span></div>';
            } else {
              defaultHtml = '<div class="set_fn screen"><span class=""><img src="' + pen + '" class="" /> Set</span></div>';
            }
            return (
              defaultHtml
            );
          },
        },
        //{ text: 'DLV', filtertype: 'textbox', datafield: 'dlv', width: '8%', cellclassname: '', },
        { text: 'Status', filtertype: 'input', datafield: 'status', width: '4%', cellclassname: '', },


        // { text: 'Console Number', filtertype: 'textbox', datafield: 'console_no', width: '12%', cellclassname: '', },
        // { text: 'Flight Date', filtertype: 'range', cellsformat: 'dd-MM-yyyy', filtermode: 'range', datafield: 'flight_date', width: '12%', cellclassname: '', },
        // { text: 'Origin country', filterable: true, datafield: 'origin_country', width: '6%', cellclassname: '', },
        // { text: 'Origin City', filterable: true, datafield: 'origin_city', width: '6%', cellclassname: '', },
        // { text: 'Destination Country', filtertype: 'textbox', datafield: 'destination_country', width: '8%', cellclassname: '', },
        // { text: 'Destination City', filtertype: 'textbox', datafield: 'destination_city', width: '8%', cellclassname: '', },
        // { text: 'Total Pices', filtertype: 'textbox', datafield: 'total_pieces', width: '8%', cellclassname: '', },
        // { text: 'Total Weight', filtertype: 'textbox', datafield: 'total_weight', width: '8%', cellclassname: '', },
        // { text: 'Total Volume', filtertype: 'textbox', datafield: 'total_volume', width: '8%', cellclassname: '', },
        // {
        //   text: 'Actions',
        //   cellsrenderer: function () {
        //     return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /></div>';
        //   },
        //   width: '5%', filterable: false,
        // },
        // { text: 'Shipment Number', filtertype: 'textbox', datafield: 'shipment_number', width: '12%', cellclassname: '', },
        // { text: 'Take In', filtertype: 'textbox', datafield: 'take_in', width: '12%', cellclassname: '', },
        // { text: ' ', filterable: false, width: '6%', cellclassname: '', },
        // {
        //   text: 'Screened', filtertype: 'textbox',
        //   cellsrenderer: function () {
        //     return '<div class="grid_actions"><span class="screen">No</span></div>';
        //   }, width: '8%', cellclassname: '',
        // },
        // { text: 'TTL Pieces', filtertype: 'textbox', datafield: 'ttl_pcs', width: '8%', cellclassname: '', },
        // { text: 'TTL Weight', filtertype: 'textbox', datafield: 'ttl_weight', width: '8%', cellclassname: '', },
        // { text: 'Location', filtertype: 'textbox', datafield: 'location', width: '8%', cellclassname: '', },
      ];
      // Nested ULD Start
      const nestedColumns = [
        // { text: 'Shipment No.', datafield: 'shipment_no', width: '8%' },
        // { text: 'Shipper', datafield: 'shipper', width: '20%' },
        // { text: 'Consigneee', datafield: 'consignee', width: '15%' },
        // { text: 'Pieces', datafield: 'pieces', width: '8%' },
        // { text: 'Weight', datafield: 'weight', width: '8%' },
        // { text: 'Volume', datafield: 'volume', width: '8%' },

        { text: 'HAWB', datafield: 'hawb', width: '10%' },
        { text: 'Shipper', datafield: 'shipper', width: '10%' },
        { text: 'Consignee', datafield: 'consignee_name', width: '10%' },
        { text: 'Packaging', datafield: 'packaging', width: '10%' },
        { text: 'Expected Pieces', datafield: 'e_pcs', width: '10%' },
        { text: 'Expected Weight', datafield: 'e_weight', width: '10%' },

      ];

      const nestedGrids = {};
      const torGrids = {};
      const initrowdetails = (index, parentElement, gridElement, record) => {
        const torGridContainer = parentElement.children[0];
        // console.log('Nested arrow clicked:', index, parentElement, gridElement, record);

        const parentRowId = record.uid.toString();
        torGrids[parentRowId] = torGridContainer;

        parentElement.addEventListener('click', (event) => {
          const target = event.target;
          // Check if the click target is the tor arrow
          if (window.$(target).hasClass('jqx-icon-arrow-right')) {
            // Handle tor arrow click here
            // console.log('Nested arrow clicked:', record);
            event.stopPropagation(); // Prevent event bubbling to the row details
          }
        });
        console.log('0000', dataAdapter);
        // const id = record.uid;
        const id = record.uid.toString();
        // console.log('jjjjjjjjjjjjj:', dataAdapter.loadedData.Rows[id]);
        const uldGrid = dataAdapter.loadedData.Rows[id]?.hawbs;

        // const nestedGridContainer = parentElement.children[0];

        // const parentRowId = record.uid.toString();
        // nestedGrids[parentRowId] = nestedGridContainer;

        // parentElement.addEventListener('click', (event) => {
        //   const target = event.target;
        //   // Check if the click target is the nested arrow
        //   if (window.$(target).hasClass('jqx-icon-arrow-right')) {
        //     // Handle nested arrow click here
        //     // console.log('Nested arrow clicked:', record);
        //     event.stopPropagation(); // Prevent event bubbling to the row details
        //   }
        // });
        // console.log(dataAdapter);
        // const id = record.uid.toString();
        // console.log('ov >>:', dataAdapter.loadedData.Rows[id]);
        // const hawbGrid = dataAdapter.loadedData.Rows[id].ids;
        // const subendPoint = `shipment/sub-expected?ids=${hawbGrid}`;
        const nestedSource = {
          datatype: 'json',
          id: 'shipmentChildID',
          datafields: [
            { name: 'id', type: 'string' },
            // { name: 'shipment_no', type: 'string' },
            // { name: 'shipper', type: 'string' },
            // { name: 'consignee', type: 'string' },
            // { name: 'pieces', type: 'string' },
            // { name: 'weight', type: 'string' },
            // { name: 'volume', type: 'string' },

            { name: 'hawb', type: 'string' },
            { name: 'shipper', type: 'string' },
            { name: 'consignee_name', type: 'string' },
            { name: 'packaging', type: 'string' },
            { name: 'e_pcs', type: 'string' },
            { name: 'e_weight', type: 'string' },
          ],
          localdata: uldGrid,

          // url: `${process.env.REACT_APP_RFS_URL}${subendPoint}`,
          // beforeSend: function (jqXHR) {
          //   jqXHR.setRequestHeader('Authorization', token);
          // },
          // // localdata: gridData[activeTab],
          // pagesize: 50,
          // filter: function (allfilters) {
          //   if (allfilters.length > 0) {
          //     setFilterApplied(true);
          //     filterForCheck = true;
          //   } else {
          //     setFilterApplied(false);
          //     filterForCheck = false;
          //   }
          //   window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
          //   window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");


          // setTimeout(() => {
          //     const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');

          //     console.log("rows", rows);
          //     (checkUlds).forEach(uldNumber => {
          //         console.log(checkUlds);
          //         rows.forEach((element, index) => {
          //             if (element.uld_number == uldNumber) {
          //                 window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
          //             }
          //         });
          //     });
          // }, 4000);

          // },
          // beforeprocessing: function (data) {
          //   source.totalrecords = data.TotalRows;
          //   setTotalRows({ totalUlds: data.activeCount });
          //   setTotalRowsR({ totalUlds: data.archiveCount });
          // },
          // sort: function () {
          //   window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
          // },
          // root: "Rows",
          // cache: false,
        }

        const nestedDataAdapter = new window.$.jqx.dataAdapter(nestedSource);

        // AWB NESTED START
        const awbColumns = [
          // { text: 'Airway Bill', datafield: 'airway_bill', width: '8%' },
          // {
          //   text: 'Pickup Status', datafield: 'pick_status', width: '10%',
          //   cellsrenderer: (row, columnfield, value, defaulthtml, columnproperties) => {
          //     if (value && Array.isArray(value)) {
          //       // Generate multiple divs for each item in the array
          //       const content = value
          //         .map((item) =>
          //           `<div class="${item.color_status || ''}">${item.status || ''}</div>`
          //         ).join(''); // Combine all divs into a single string

          //       return `<div class="stats_view">${content}</div>`;
          //     }
          //     // Fallback if value is not an array or empty
          //     return defaulthtml;
          //   }
          // },
          { text: 'Packaging', datafield: 'packaging', width: '8%' },
          { text: 'Expected Pieces', datafield: 'e_pcs', width: '10%' },
          { text: 'Expected Weight', datafield: 'e_weight', width: '10%' },

          // Add more columns as needed
        ];
        const awbGrids = {};
        const awbrowdetails = (index, parentElement, gridElement, record) => {
          const awbGridContainer = parentElement.children[0];
          // console.log('Nested arrow clicked:', index, parentElement, gridElement, record);

          const parentRowId = record.uid.toString();
          awbGrids[parentRowId] = awbGridContainer;

          parentElement.addEventListener('click', (event) => {
            const target = event.target;
            // Check if the click target is the awb arrow
            if (window.$(target).hasClass('jqx-icon-arrow-right')) {
              // Handle awb arrow click here
              // console.log('Nested arrow clicked:', record);
              event.stopPropagation(); // Prevent event bubbling to the row details
            }
          });
          // console.log(dataAdapter);
          // const id = record.uid;
          const id = record.uid.toString();
          // console.log('sss:', dataAdapter.loadedData.Rows[id]);
          const uldGrid = nestedDataAdapter.loadedData[id]?.packing_groups;
          // console.log('jjjjjjjjjjjjj:', uldGrid);

          const awbSource = {
            datatype: 'json',
            id: 'shipmentChildID',
            datafields: [
              { name: 'packaging', type: 'string' },
              { name: 'e_pcs', type: 'string' },
              { name: 'e_weight', type: 'string' },

            ],
            localdata: uldGrid,
          }

          const awbDataAdapter = new window.$.jqx.dataAdapter(awbSource);

          const awbGridOptions = {
            width: '100%',
            pageable: false,
            sortable: false,
            // pageSize: 15,
            autoheight: false,
            height: (6 * 45),
            selectionmode: '',
            rowsheight: 45,
            source: awbDataAdapter,
            filterable: false,
            columns: awbColumns,

            // rowdetails: true,

            rowsheight: 45,
            showemptyrow: false,
            ready: function () {
              // Manually set row IDs starting from 0
              const rows = window.$(awbGridContainer).jqxGrid('getrows');
              for (let i = 0; i < rows.length; i++) {
                const rowid = i; // Use index as the new row ID
                const row = rows[i];
                window.$(awbGridContainer).jqxGrid('setcellvalue', row.uid, 'uid', rowid);
                window.$(awbGridContainer).jqxGrid('updaterow', rowid, row);
                window.$(awbGridContainer).find(`[role="row"][row-id="${row.uid}"]`).attr('row-id', rowid);
              }
            },
          };
          window.$(awbGridContainer).jqxGrid(awbGridOptions);

        };

        const nestedGridOptions = {
          width: '100%',
          pageable: false,
          sortable: false,
          // pageSize: 15,
          autoheight: false,
          height: (10 * 45),
          selectionmode: '', // checkbox
          source: nestedDataAdapter,
          filterable: false,
          columns: nestedColumns,
          rowdetails: true,
          initrowdetails: awbrowdetails,
          rowdetailstemplate: {
            rowdetails: '<div id="awbGrid" style="margin: 10px;"></div>',
            rowdetailsheight: (10 * 45),
            rowdetailshidden: true,
          },
          rowsheight: 45,
          showemptyrow: false,
          ready: function () {
            const rows = window.$(torGridContainer).jqxGrid('getrows');
            for (let i = 0; i < rows.length; i++) {
              const rowid = i;
              const row = rows[i];
              window.$(torGridContainer).jqxGrid('setcellvalue', row.uid, 'uid', rowid);
              window.$(torGridContainer).jqxGrid('updaterow', rowid, row);
              window.$(torGridContainer).find(`[role="row"][row-id="${row.uid}"]`).attr('row-id', rowid);
            }
          },
        };
        window.$(torGridContainer).jqxGrid(nestedGridOptions);


      };
      // Nested End
      const gridOptions = {
        width: '100%',
        source: dataAdapter,
        columns: columns,
        autoheight: false,
        height: 1040,
        sortable: true,
        altrows: false,
        columnsresize: false,
        enabletooltips: false,
        editable: false,
        selectionmode: 'checkbox',
        pageable: true,
        pageSize: 20,
        pagesizeoptions: ['50', '100', '200', '500'],
        pagerButtonsCount: 5,
        pagerMode: 'advanced',
        filterable: true,
        filterrowheight: 45,
        showfilterrow: true,
        rowsheight: 42,
        columnsheight: 45,
        showstatusbar: true,
        virtualmode: true,
        initrowdetails: initrowdetails,
        rowdetails: true,
        rowdetailstemplate: {
          rowdetails: '<div id="nestedGrid" style="margin: 10px;"></div>',
          rowdetailsheight: (10 * 45),
          rowdetailshidden: true,
        },
        rendergridrows: function (params) {
          return params.data;
        },
        ready: function () {
          const searchValue = localStorage.getItem('link_mawb');
          if (searchValue) {
            setTimeout(() => {
              autoSearchAndSelect(searchValue, 'mawb');
              localStorage.removeItem('link_mawb');
            }, 1000);
          }
        },
        // rendered: function () {
        //   const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
        //   (checkUlds).forEach(uldNumber => {
        //     rows.forEach((element, index) => {
        //       if (element.uld_number == uldNumber) {
        //         window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
        //       }
        //     });
        //   });
        // }
      };
      window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
      window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');
      window.$(gridRefs[activeTab].current).on('click', '.row_edit', function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
        const dataToSend = {
          uld_number: rowData.uld_number,
          type_code: rowData.type_code,
          serial_number: rowData.serial_number,
          owner_code: rowData.owner_code,
          condition_code: rowData.condition_code,
          asset_type: rowData.asset_type == 'Y' ? false : true
        };
        // setEditData(dataToSend);
        // setShowEdit(true);
      });
      window.$(gridRefs[activeTab].current).on('click', '.row_trash', function () {
        localStorage.removeItem('EditFlight')
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);

        if (boundIndex !== undefined) {
          const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
          const pageIndex = pagingInfo.pagenum;
          const pageSize = pagingInfo.pagesize;
          const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
          // console.log('Global Index:', globalIndex); 
          const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);
          console.log('rowData', rowData);
          handleModalOpen('cancelForm')
          setDeleteId(rowData.ids);

        } else {
          console.error('Bound index could not be retrieved. Check the row index and data binding.');
        }
        // const rowData = window.$(gridRefs[activeTab]s[activeTab].current).jqxGrid('getrowdata', rowIndex);

      });
      window.$(gridRefs[activeTab].current).on('click', '.row_view', function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);

        if (boundIndex !== undefined) {
          const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
          const pageIndex = pagingInfo.pagenum;
          const pageSize = pagingInfo.pagesize;
          const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
          // console.log('Global Index:', globalIndex); 
          const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);
          if (rowData) {
            // const innerData = rowData.import_shipment_record_id;
            // localStorage.removeItem('SHEdit');
            // localStorage.setItem('SHEdit', JSON.stringify(innerData));
            // window.location.href = '/ForwarderShipments/ExpectedDetails'
            const innerData = rowData.import_shipment_record_id;
            localStorage.removeItem('SHEdit');
            // loadDetails(rowData.id);
            localStorage.setItem('SHEdit', JSON.stringify(innerData));
            localStorage.setItem('ccbackUrl', '/ForwarderShipments/Import');
            localStorage.setItem('AddShipmentType', 'import');
            history.push('/ForwarderShipments/AddShipmentRecords');
          } else {
            console.error('No data found for the given row index.');
          }
        } else {
          console.error('Bound index could not be retrieved. Check the row index and data binding.');
        }
      });
      window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
        window.$(row).on('mouseover', () => {
          window.$(row).addClass('row-hover');
        });
        window.$(row).on('mouseout', () => {
          window.$(row).removeClass('row-hover');
        });
      });
      window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
        if (event.args.row) {
          const selectedRow = event.args.row;
          const uldNumber = selectedRow.id;
          const selectedRowId = selectedRow.uid;
          if (!checkUlds.includes(uldNumber)) {
            checkUlds.push(uldNumber);
          }
          // console.log(checkUlds);
          // if (!gridSelect.some(row => row.uld_number === uldNumber)) {
          //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
          // }
          setGridSelect(prevGridSelect => {
            if (!prevGridSelect.some(row => row.id === uldNumber)) {
              return [...prevGridSelect, selectedRow];
            }
            return prevGridSelect;
          });
        } else {
          if (event.args.rowindex.length > 0) {
            const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
            setGridSelect(allIds);
          } else {
            setGridSelect([]);
          }
        }
      });
      window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
        if (event.args.row) {
          const unselectedRowId = event.args.row.id;
          setGridSelect(prevSelection => prevSelection.filter(row => row.id !== unselectedRowId));
          // if(filterForCheck!=true){
          if (!checkUlds.includes(unselectedRowId)) {
            checkUlds.push(unselectedRowId);
          } else {
            checkUlds = checkUlds.filter(item => item !== unselectedRowId);
          }
          // }
          // console.log(checkUlds);

        }
      });
      window.$(gridRefs[activeTab].current).off('cellclick');
      window.$(gridRefs[activeTab].current).on('cellclick', (event) => {
        const args = event.args.row.bounddata;
        if (event.args.columnindex > 1 && !([12, 13, 14, 15, 16].includes(event.args.columnindex))) {
          if (gridSelect) {
            gridSelect.forEach(item => {
              const selectedRowBoundIndex = item.boundindex;
              window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
            });
          }
          // loadDetails(args.uld_number);
          setSelectedRowData(args)
          setTimeout(() => {
            window.$(gridRefs[activeTab].current).jqxGrid('refresh');
          }, 30);
        } else if ([12, 13, 14, 15, 16].includes(event.args.columnindex)) {
          const rowIndex = event.args.rowindex;
          const columnField = event.args.datafield;
          const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
          handleSetFunction(columnField, rowData?.import_shipment_record_id, rowData[columnField])
        }
      });
      // }
    }
  }, [gridData]);

  const autoSearchAndSelect = (searchValue, searchField = 'mawb') => {
    if (!gridRefs[activeTab]?.current || !searchValue) return;
    console.log('searchValue', searchValue);
    const filterGroup = new window.$.jqx.filter();
    const filter = filterGroup.createfilter('stringfilter', searchValue, 'contains');
    filterGroup.addfilter(0, filter);
    window.$(gridRefs[activeTab].current).jqxGrid('addfilter', searchField, filterGroup);
    window.$(gridRefs[activeTab].current).jqxGrid('applyfilters');


    setTimeout(() => {
      const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
      if (rows && rows.length > 0) {
        const matchingRowIndex = rows.findIndex(row =>
          row[searchField] && row[searchField].toString().toLowerCase().includes(searchValue.toLowerCase())
        );
        if (matchingRowIndex !== -1) {
          window.$(gridRefs[activeTab].current).jqxGrid('selectrow', matchingRowIndex);
          window.$(gridRefs[activeTab].current).jqxGrid('ensurerowvisible', matchingRowIndex);
          const selectedRow = rows[matchingRowIndex];
          setGridSelect(prevGridSelect => {
            const alreadySelected = prevGridSelect.some(row => row.id === selectedRow.id);
            if (!alreadySelected) {
              return [...prevGridSelect, selectedRow];
            }
            return prevGridSelect;
          });
          setTimeout(() => {
            handleDropdownItemClick('T', 'B', true, selectedRow);
          }, 300); // Increased timeout to ensure state is updated
        }
      }
    }, 500);
  };

  const loadDetails = (id) => {
    localStorage.removeItem('SHEdit');
    localStorage.setItem('SHEdit', JSON.stringify(id));
    localStorage.setItem('ccbackUrl', '/ForwarderShipments/Import');
    localStorage.setItem('AddShipmentType', 'import');
    history.push('/ForwarderShipments/AddShipmentRecords');
  }
  const handleCloseClick = () => {
    setSelectedRowData(null);
    setTimeout(() => {
      window.$(gridRefs[activeTab].current).jqxGrid('refresh');
    }, 30);
  };
  // upload Section
  const [showModalUpload, setShowModalUpload] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [files, setFiles] = useState([]);
  const fileInputRef = useRef(null);
  const [base64Files, setBase64Files] = useState([]);

  // const imageModalUpload = (id) => {
  //     setSelectedRowId(id);
  //     setShowModalUpload(true)
  //     setFiles([])
  // }
  const imageModalUpload = (id) => {
    const selectedRowFiles = gridSelect.find(item => item.uid === id)?.files || [];
    setFiles(selectedRowFiles);
    setSelectedRowId(id); // Store the ID of the selected row
    setShowModalUpload(true);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
    getBase64(droppedFiles[0]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDeleteFile = (index) => {
    setFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      newFiles.splice(index, 1);
      return newFiles;
    });
    base64Files.splice(index, 1);
  };

  const handleBrowseFiles = (e) => {
    e.preventDefault();
    fileInputRef.current.click();
  };

  function getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  // const handleFileChange = (e) => {
  //     const selectedFiles = Array.from(e.target.files);
  //     const filesWithBase64 = [];
  //     selectedFiles.forEach((file) => {
  //         const reader = new FileReader();
  //         reader.onloadend = () => {
  //             filesWithBase64.push({ file, base64: reader.result });
  //             if (filesWithBase64.length === selectedFiles.length) {
  //                 setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => obj.file)]);

  //             }
  //         };
  //         reader.readAsDataURL(file);
  //     });
  // }
  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);

    const input = event.target;
    if (input.files && input.files[0]) {
      const file = input.files[0];
      setFileName(file.name);
      setSelectedFile(file);
    }
    const selectedFiles = Array.from(event.target.files);
    const filesWithBase64 = [];

    selectedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        filesWithBase64.push({ "base64": reader.result, "file_name": file.name });

        if (filesWithBase64.length === selectedFiles.length) {
          setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
          setBase64Files((prevBase64Files) => [...prevBase64Files, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
        }
      };
      reader.readAsDataURL(file);
    });
  };
  const imageUpload = () => {
    setGridSelect(prevGridSelect =>
      prevGridSelect.map(item => {
        if (item.uid === selectedRowId) {
          return { ...item, files: files, base64Files: base64Files };
        }
        return item;
      })
    );
    setShowModalUpload(false);
  };
  // upload forward
  const imageUploadRef = useRef(null);
  const browseClick = () => {
    if (imageUploadRef.current) {
      imageUploadRef.current.handleBrowseFiles();
    }
  };
  // +++++++++++++++++++++++++++++++++++ Silk Slider
  const findPrimary = selectedRowData?.attachments?.filter((attachment) => attachment.primary === 1);
  const [show, setShow] = useState(false);
  const [selectedFile, setSelectedFile] = useState('');
  const [hawbShow, setHawbShow] = useState(true);

  const handleFileClick = (file) => {
    setSelectedFile(file);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setSelectedFile('');
  };



  const isModalClose = () => {
    setIsModal(false);
  }

  const resetFilters = () => {
    window.$(gridRefs[activeTab].current).jqxGrid('clearfilters');
    // gridSelect.forEach(item => {
    //     const selectedRowBoundIndex = item.boundindex;
    //     window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
    // });
    // setGridSelect([]);
  };

  const createCargo = () => {
    localStorage.setItem('ccbackUrl', '/ForwarderShipments/Import');
    history.push('/ForwarderShipments/CreateCargo');
  }

  const [deleteId, setDeleteId] = useState('');
  //---------------- upload data files start------------------------>

  const handleFormChange = (name, value) => {
  if (name === 'mawb') {
    value = handleChange(value);
  }

  const flightFields = ['flight_code','flight_number','flight_date','eta','origin','destination'];

  if (flightFields.includes(name)) {
    setFormData(prev => ({
      ...prev,
      flight_details: [
        {
          ...prev?.flight_details[0],
          [name]: value
        }
      ]
    }));
  } else {
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  }
};


  const handleModalOpen = (contentType) => {
    setModalContent(contentType);
    setShowModal(true);
  };

  const validateModal = () => {
    if (modalFor === 'B') {
      for (let i = 0; i < shipmentGroups.length; i++) {
        const group = shipmentGroups[i];
        const hawbNumber = group.hawb || `HAWB ${i + 1}`;

        // Common validation for accepted pieces
        if (!group.a_pcs || group.a_pcs === "") {
          toast.error(`Accepted pieces is required for ${hawbNumber}`);
          return false;
        }

        // Conditional validations based on switchData
        if (switchData) {
          if (!group.warehouse_in || group.warehouse_in === "") {
            toast.error(`Warehouse In is required for ${hawbNumber}`);
            return false;
          }

          if (!group.warehouse_in_doc_type || group.warehouse_in_doc_type === "" || group.warehouse_in_doc_type === "-") {
            toast.error(`Doc Type is required for ${hawbNumber}`);
            return false;
          }

          if (group.warehouse_in_doc_type !== 'Transfer') {
            if (!group.warehouse_in_doc_no || group.warehouse_in_doc_no === "") {
              toast.error(`DOC No is required for ${hawbNumber}`);
              return false;
            }
          }
        }
      }
    } else {
      // toast.error("Modal A validation - different validation logic here");
      if (!formData.mawb || formData.mawb === "") {
        toast.error(`Master Airway Bill is required.`);
        return false;
      }
      if (!formData.expected_pieces || formData.expected_pieces === "") {
        toast.error(`Expected pieces is required`);
        return false;
      }
      if (savedHouseAwbs && savedHouseAwbs.length > 0) {
        for (let i = 0; i < savedHouseAwbs.length; i++) {
          const awb = savedHouseAwbs[i];
          const hawbNumber = awb.hawb_no || `HAWB ${i + 1}`;
          // if (!awb.hawb_no || awb.hawb_no === "" || awb.hawb_no === "0") {
          //       toast.error(`HAWB No. is required`);
          //       return false;
          //     }

          if (awb.packing_groups && awb.packing_groups.length > 0) {
            for (let j = 0; j < awb.packing_groups.length; j++) {
              const packingGroup = awb.packing_groups[j];
              if (!packingGroup.e_pcs || packingGroup.e_pcs === "" || packingGroup.e_pcs === "0") {
                toast.error(`Expected pieces is required in ${hawbNumber}`);
                return false;
              }
            }
          }
        }
      }
    }

    return true;
  };

  const handleCheckSubmit = () => {
    const invalidItem = shipmentGroups.find(item => parseFloat(item.a_pcs) > parseFloat(item.e_pcs));
    if (invalidItem)
      setConfirmModal(true);
    else
      handleConfirmation();
  }

  const handleConfirmation = async (shouldContinue = false) => {
    let endPoint = '';
    let payload = {};
    if (modalFor === 'B') {
      if (!validateModal()) {
        return;
      }
      endPoint = 'shipment/move-to-in-stock';
      // payload = { ...formData, packing_groups: shipmentGroups }
      payload = {
        mawb_id: modalData?.id, // Ensure this is an ID

        hawb_details: shipmentGroups.map(item => ({
          id: item.id,
          accepted_pcs: item.a_pcs,
          accepted_weight: item.a_weight,
          expected_weight: item.e_weight,
          location: item.location,
          temparature: item.temparature,
          temperature_type: item.temperature_type,
          warehouse_in: item.warehouse_in,
          warehouse_in_doc_type: item.warehouse_in_doc_type,
          warehouse_in_doc_no: item.warehouse_in_doc_no,
        }))
      };
    } else {
      if (!validateModal()) {
        return;
      }
      let finalHawbs = savedHouseAwbs;

      if (savedHouseAwbs.length === 0) {
        const defaultHawb = {
          hawb_no: formData.mawb,
          packing_groups: [
            {
              packaging: formData.packaging || '',
              e_pcs: formData.expected_pieces || '',
              e_weight: formData.expected_weight || '',
            }
          ]
        };
        finalHawbs = [defaultHawb];
      }

      endPoint = 'shipment/import-shipment-consolidated-save';
      payload = { ...formData, hawbs: finalHawbs };
    }
    // console.log("🚀 ~ handleConfirmation ~ payload:", payload)
    try {
      const res = await withRFSToken.post(endPoint, payload)
      //.then(function (res) {
      if (res.data.response_code == 200) {
        const innerData = res.data.response_data;
        setTimeout(() => {
          setIsLoading(false);
          window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata')
        }, 1);
        setIsContinue(false);
        setConfirmModal(false);
        gridSelect.forEach(item => {
          const selectedRowBoundIndex = item.boundindex;
          window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
        });
        setGridSelect([]);
        setMawbModal(false);
        setFormData(JSON.parse(JSON.stringify(initialFormData)));
        setSavedHouseAwbs([]);
        setHouseAwbInput('');
        setHawbShow(true);
        toast.success(res.data.response_msg);
        // });}
      } else {
        toast.error(res.data.response_msg);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
    // window.location.href = '/ULDControl'

  }

  const handleModalRadioChange = (event) => {
    const { name, value } = event.target;
    setModalRadioValue({ [name]: value });
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      toast.error("Please select a file first!");
      return;
    }
    // setUploading(true);
    // console.log('300', selectedFile);
    // console.log('301', base64Files[0]);

    if (selectedFile) {
      try {
        const res = await withRFSToken.post('shipment-export/upload-planning-data', { excelData: base64Files[0] });
        if (res.data.responseCode == 1) {
          toast.success('File uploaded successfully!');
          setTimeout(() => {
            setIsLoading(false);
            window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata')
          }, 1);
        }
      } catch (error) {
        console.error("There was an error uploading the file!", error);
      } finally {
        setShowModal(false);
      }
    }
  };

  const handleModalUpdate = () => {
    const updatedAssetType = modalRadioValue.assetType === 'O' ? false : true;
    const updatedFormData = {
      ...formData,
      asset_type: updatedAssetType,
      uldInfo: formData.uldInfo.map(stack => ({
        ...stack,
        asset_type: updatedAssetType
      }))
    };
    setFormData(updatedFormData);
    setModalRadioValue('')
    setShowModal(false);
  };

  const handleDownloadClick = () => {
    const a = document.createElement('a');
    a.href = XLSFILE;
    a.download = 'expected_template.xls'; // Name for the downloaded file
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  const handleChange = (value) => {
    value = value.replace(/[^\d]/g, ''); // Remove any non-numeric characters
    let formattedValue = '';

    // Add a hyphen after the third character
    if (value.length > 3) {
      formattedValue += value.substr(0, 3) + '-';
      value = value.substr(3);
    }

    // Add a space after the eighth character
    if (value.length > 4) {
      formattedValue += value.substr(0, 4) + ' ';
      value = value.substr(4);
    }

    formattedValue += value;
    return formattedValue.substr(0, 13);
  };

  const [shipmentGroups, setShipmentGroups] = useState([
    { packaging: '', e_pcs: '', e_weight: '', files: [], piecesConfirm: "NO" }
  ]);

  const handleAddGroup = () => {
    setShipmentGroups([
      ...shipmentGroups,
      { packaging: '', e_pcs: '', e_weight: '', files: [] }
    ]);
  };

  const handleGroupChange = (index, field, value) => {
    const updatedGroups = [...shipmentGroups];
    updatedGroups[index][field] = value;

    if (field === 'a_pcs') {
      const expectedPcs = parseFloat(updatedGroups[index].e_pcs) || 0;
      const expectedWeight = parseFloat(updatedGroups[index].e_weight) || 0;
      const acceptedPcs = parseFloat(value) || 0;

      // if (acceptedPcs > expectedPcs) {
      //     toast.error("Accepted pieces can't be greater than Expected Pieces", {
      //     toastId: "pcs-limit-error"
      //     });
      //    return; 
      // }


      if (expectedPcs > 0) {
        const ratio = acceptedPcs / expectedPcs;
        const calculatedWeight = (expectedWeight * ratio).toFixed(2);
        updatedGroups[index].a_weight = calculatedWeight;
      }
    }

    // if(field == 'a_weight'){
    //   if(updatedGroups[index].a_weight > updatedGroups[index].e_weight){
    //     toast.error("Accepted weight can't be greater than Expected Weight", {
    //     toastId: "weight-limit-error"
    //     });
    //     return;
    //   }
    // }

    // if (field === 'a_weight') {
    //   const acceptedPcs = parseFloat(updatedGroups[index].a_pcs) || 0;
    //   const acceptedWeight = parseFloat(value) || 0;
    //   const expectedPcs = parseFloat(updatedGroups[index].e_pcs) || 0;

    //   if (acceptedPcs > 0) {
    //     const weightPerPiece = acceptedWeight / acceptedPcs;
    //     const newExpectedWeight = (weightPerPiece * expectedPcs).toFixed(2);
    //     updatedGroups[index].e_weight = newExpectedWeight;
    //   }
    // }

    setShipmentGroups(updatedGroups);
  };

  const handleGroupFileChange = (index, event) => {
    const selectedFiles = Array.from(event.target.files);
    const updatedGroups = [...shipmentGroups];
    updatedGroups[index].files = [...(updatedGroups[index].files || []), ...selectedFiles];
    setShipmentGroups(updatedGroups);
  };

  const handleGroupDrop = (index, e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    const updatedGroups = [...shipmentGroups];
    updatedGroups[index].files = [...(updatedGroups[index].files || []), ...droppedFiles];
    setShipmentGroups(updatedGroups);
  };

  const handleGroupDragOver = (e) => {
    e.preventDefault();
  };

  const handleGroupDeleteFile = (groupIdx, fileIdx) => {
    const updatedGroups = [...shipmentGroups];
    updatedGroups[groupIdx].files = updatedGroups[groupIdx].files.filter((_, idx) => idx !== fileIdx);
    setShipmentGroups(updatedGroups);
  };

  const handleDeleteGroup = (groupIdx) => {
    setShipmentGroups(prevGroups => prevGroups.filter((_, idx) => idx !== groupIdx));
  };

  const [savedHouseAwbs, setSavedHouseAwbs] = useState([]);
  const [houseAwbInput, setHouseAwbInput] = useState('');
  const [editIndex, setEditIndex] = useState(null);

  //   const calculateTotalExpectedPieces = (houseAwbsArray) => {
  //   let totalPieces = 0;
  //   houseAwbsArray.forEach(hawb => { if (hawb.packing_groups && hawb.packing_groups.length > 0) { hawb.packing_groups.forEach(group => { if (group.e_pcs) { totalPieces += parseInt(group.e_pcs) || 0; } }); } });
  //   return totalPieces;
  // };

  const calculateTotalExpectedPieces = (houseAwbsArray) => {
    return houseAwbsArray.reduce((total, hawb) => total + (hawb.packing_groups ? hawb.packing_groups.reduce((groupTotal, group) => groupTotal + (parseInt(group.e_pcs) || 0), 0) : 0), 0);
  };
  const calculateTotalExpectedWeight = (houseAwbsArray) => {
    return houseAwbsArray.reduce((total, hawb) => total + (hawb.packing_groups ? hawb.packing_groups.reduce((groupTotal, group) => groupTotal + (parseFloat(group.e_weight) || 0), 0) : 0), 0);
  };

  // const handleSaveHawb = () => {
  //   if (!houseAwbInput.trim()) {
  //     toast.error("House AWB's is required!");
  //     return;
  //   }
  //   let updatedHouseAwbs;
  //   if (editIndex !== null) {
  //     // Update existing
  //     setSavedHouseAwbs(prev => prev.map((item, idx) => idx === editIndex ? { hawb_no: houseAwbInput, packing_groups: shipmentGroups } : item));
  //     setEditIndex(null);
  //   } else {
  //     setSavedHouseAwbs(prev => [...prev, { hawb_no: houseAwbInput, packing_groups: shipmentGroups }]);
  //   }
  //   setShipmentGroups([{ packaging: '', e_pcs: '', e_weight: '', files: [] }]);
  //   setHouseAwbInput('');

  //   setHawbShow(false)
  // };
  const handleSaveHawb = () => {
    if (!houseAwbInput.trim()) { toast.error("House AWB's is required!"); return; }
    let updatedHouseAwbs;
    if (editIndex !== null) { updatedHouseAwbs = savedHouseAwbs.map((item, idx) => idx === editIndex ? { hawb_no: houseAwbInput, packing_groups: shipmentGroups } : item); }
    else { updatedHouseAwbs = [...savedHouseAwbs, { hawb_no: houseAwbInput, packing_groups: shipmentGroups }]; }
    setSavedHouseAwbs(updatedHouseAwbs);
    const totalExpectedPieces = calculateTotalExpectedPieces(updatedHouseAwbs);
    const totalExpectedWeight = calculateTotalExpectedWeight(updatedHouseAwbs);
    setFormData(prevFormData => ({ ...prevFormData, expected_pieces: totalExpectedPieces.toString(), expected_weight: totalExpectedWeight.toString() }));
    setEditIndex(null);
    setShipmentGroups([{ packaging: '', e_pcs: '', e_weight: '', files: [] }]);
    setHouseAwbInput('');
    setHawbShow(false);
  };
  const handleCancelHawb = () => {
    setEditIndex(null);
    setShipmentGroups([{ packaging: '', e_pcs: '', e_weight: '', files: [] }]);
    setHouseAwbInput('');
    setHawbShow(false);
  };

  const handleEditHawb = (idx) => {
    setShipmentGroups(savedHouseAwbs[idx].packing_groups);
    setHouseAwbInput(savedHouseAwbs[idx].hawb_no);
    setEditIndex(idx);
    setHawbShow(true)
  };
  const handleDeleteHawb = (idx) => {
    const updatedHouseAwbs = savedHouseAwbs.filter((_, i) => i !== idx);
    setSavedHouseAwbs(updatedHouseAwbs);
    const totalExpectedPieces = updatedHouseAwbs.length === 0 ? 0 : calculateTotalExpectedPieces(updatedHouseAwbs);
    const totalExpectedWeight = updatedHouseAwbs.length === 0 ? 0 : calculateTotalExpectedWeight(updatedHouseAwbs);
    setFormData(prevFormData => ({ ...prevFormData, expected_pieces: totalExpectedPieces.toString(), expected_weight: totalExpectedWeight.toString() }));
    if (editIndex === idx) {
      setShipmentGroups([{ packaging: '', e_pcs: '', e_weight: '', files: [] }]);
      setHouseAwbInput('');
      setEditIndex(null);
    }
  };

  const TemperatureOptions = [
    { label: 'Celsius', value: 'C' },
    { label: 'Fahrenheit', value: 'F' },
  ];

  const handleMoveToActArc = (info) => {
    if (gridSelect.length <= 0) {
      toast.error('Please select Quotation first');
    } else {
      setShowConfirmation(true);
      // setConfirmationInfo(info)
      // setModalAction(() => confirmMoveToActArc); // Set the action to be performed on confirmation
    }
  };
  const confirmMoveToActArc = async () => {
    const ids = gridSelect?.map(data => data.id)
    try {
      const res = await withRFSToken.post('shipment/toggle-archive-import-shipment', { ids: ids })
        .then(function (res) {
          if (res.data.response_code == 200) {
            toast.success(res.data.response_msg);
            gridSelect.forEach(item => {
              const selectedRowBoundIndex = item.boundindex;
              window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
            });
            setGridSelect([]);
            window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
            setShowConfirmation(false);
          }
        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const handleDownload = async () => {
    try {
      const ids = gridSelect?.map(data => data.id) || [];
      const status = activeTab == 'active' ? 'A' : activeTab == 'archive' ? 'D' : 'M';

      const payload = {
        tab_name: 'Expected',
        fields: '',
        ids: ids,
        status: status
      };

      const res = await withRFSToken.post('shipment/download-import-shipment', payload, {
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Expected_${activeTab}_${new Date().getTime()}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      toast.success('Downloaded successfully');
      setGridSelect([]);
      window.$(gridRefs[activeTab].current).jqxGrid("clearselection");
      window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata");
    } catch (error) {
      console.error('Error downloading data:', error);
      toast.error('Failed to download data');
    }
  }

  const handleCustomerModal = (type = 'shipper') => {
     setCustomerModalType(type);
     setCustomerModal(true);
     setCustomerData({ agent_or_customer: 'C' })
  }
   const hideCustomerModal = () => {
        setCustomerModal(false);
    };
    const handleCustomerChange = (name, value) => {
        setCustomerData(prevData => ({
            ...prevData,
            [name]: value
        }));

        // Clear validation error for this field when user starts typing
        // if (validationErrors[name]) {
        //     setValidationErrors(prev => {
        //         const newErrors = { ...prev };
        //         delete newErrors[name];
        //         return newErrors;
        //     });
        // }
    };
    const handleCustomerSave = async () => {
        // Validate required fields
        if (!customerData.name) {
            toast.error('Customer Name is required');
            return;
        } else if (!isModal && !customerData.agent_or_customer) {
            toast.error('Customer/Agent is required');
            return;
        } else if (!customerData.customer_type) {
            toast.error('Customer Type is required');
            return;
        } else if (customerData.customer_type === 'F' && !customerData.agent_code) {
            toast.error('Agent Code is required when Customer Type is Forwarder');
            return;
        }

        try {
            const res = await withRFSToken.post('address-book/add-update', customerData)
                .then(function (res) {
                    const innerData = res.data.response_data;
                    if (res.data.response_code != 200) {
                        toast.error(res.data.response_msg)
                        return;
                    }
                    toast.success(res.data.response_msg);
                    if (customerData.customer_type === 'S') {
                        fetchShipperConsignee('Shipper');
                    } else if (customerData.customer_type === 'C') {
                        fetchShipperConsignee('Consignee');
                    }
                    setCustomerModal(false);
                    setCustomerData({ agent_or_customer: 'C' })
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

  return (
    <>
      <div className="mb-3 nestedtabs rounded minh">
        <div className='d-flex'>
          <button className="addtruck me-2" variant="primary" onClick={() => handleDropdownItemClick('T', 'C')}>
            <span> <FontAwesomeIcon icon={faPlus} /> Add Shipment</span>
          </button>
          <Dropdown>
            <Dropdown.Toggle variant="light" id="dropdown-basic" className='action'>
              <FontAwesomeIcon icon={faGear} /> Actions <FontAwesomeIcon icon={faChevronDown} />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => handleDropdownItemClick('T', 'B')}>Move In Stock</Dropdown.Item>
              <Dropdown.Item onClick={() => handleMoveToActArc(activeTab === 'Active' ? 'R' : 'A')}>
                {activeTab != 'archive' ? 'Move to Archive' : 'Move to Active'}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <div className='ulddown'>
            <button onClick={() => handleModalOpen('import')} ><img src={Export} /> Upload Data</button>
            <button onClick={handleDownload}>
              <img src={Export} alt="export" /> Download
            </button>
          </div>
        </div>
      </div>
      <div className="maindiv">
        <div className='trashdonload position-relative'>
          {/* {!isLoading && <>
            {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
            <div ref={gridRefs[activeTab]} className='bookinggrid' ></div></>} */}
          <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="booking_tab">
            <Tab eventKey="active" title={<span>Open</span>} className='moveto'>
              {/* <Loader isLoading={isLoading} /> */}
              {!isLoading && <>
                {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                <div ref={gridRefs.active} className='bookinggrid' ></div>
              </>
              }
              {/* <div ref={gridRefs.Active} className='bookinggrid' ></div> */}
            </Tab>
            <Tab eventKey="mismatch" title={<span>Mismatch <Badge className="rabadge">{totalRows}</Badge></span>} className='moveto'>
              {!isLoading && <>
                {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                <div ref={gridRefs.mismatch} className='bookinggrid' ></div>
              </>
              }
            </Tab>
            <Tab eventKey="archive" title={<span>Archive</span>} className='moveto'>
              {/* <Loader isLoading={isLoading} /> */}
              {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
              {!isLoading && <div ref={gridRefs.archive} className='bookinggrid' ></div>}
              {/* <div ref={gridRefs.Trash} className='bookinggrid' ></div> */}
            </Tab>
          </Tabs>
        </div>
        {selectedRowData && (
          <div className='SecondDiv mt-45'>
            <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button>
            <div className='girddtals_header'>
              <h3>
                {selectedRowData.mawb} &nbsp; <span>{selectedRowData.status}</span>
              </h3>
              <div className='d-flex actbtn justify-content-between'>
                <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                <div className='viwall' onClick={() => loadDetails(selectedRowData?.import_shipment_record_id)}><Link to='#'>Details</Link></div>

              </div>

            </div>
            <div className='mt-3'>
              <div className='mb-3'>
                <h3>Highlighted Image(s)</h3>
                {selectedRowData?.attachments && (
                  <div className='main_primary'>
                    {findPrimary.map((file, index) => {
                      const fileName = file?.file_name;
                      const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                      const extension = fileName?.split(".").pop();
                      return (
                        <>
                          <div key={`ns_${index}`} className='primary_image'>
                            {["jpeg", "jpg", "png", "webp"].includes(file.file_path?.split(".")[file.file_path?.split(".").length - 1]
                            ) ? (
                              <div>
                                <img
                                  src={file.file_path}
                                  alt="Preview"
                                  style={{
                                    maxWidth: "100%",
                                    maxHeight: "100%",

                                  }}
                                  // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                  onClick={() =>
                                    handleFileClick(file.file_path)
                                  }
                                />
                              </div>
                            ) : (
                              <>
                                <span className="">
                                  <img src={Docmnt} className="fileimg" />
                                </span>
                              </>
                            )}
                            <span className="rafilename">
                              {baseName?.length <= 5 ? fileName : `${baseName?.substring(0, 5)}... .${extension}`}
                            </span>
                          </div>
                        </>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>

            <ImageUpload
              ref={imageUploadRef}
              attachable_type={"uld"}
              attachable_id={selectedRowData.uld_number}
              attachments={selectedRowData.attachments}
              onDeleteSuccess={() => loadDetails(selectedRowData.uld_number)}
            />
            <ActivityComments
              commentable_type={"uld"}
              commentable_id={selectedRowData.uld_number}
              allactivities={selectedRowData.activities}
              onReloadDetails={loadDetails}
            />
          </div>
        )}
      </div>
      <Modal show={isModal} onHide={!isSaving ? isModalClose : null} className='addfrom change_type' centered>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <h3>Confirm Screened</h3>
          <p>If you proceed with the change, user data will be removed. <br /> Are you sure you want to continue? </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" disabled={isSaving} className='position-relative'>
            {isSaving ? <>Update Screened<div className='mvt loader-container' style={{ height: 41 + 'px' }}><span className='mvt loader' style={{ top: 3 + 'px', left: 45 + '%' }}></span></div></> : 'Update Screened'}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showModal} onHide={handleModalClose} className='addfrom change_type' centered>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          {modalContent === 'import' && (
            <>
              <h3>Import Excel</h3>
              <p>Upload the filled in template</p>
              <div className='asset_midle'>

                <div className='upload_tmpl'>
                  <button onClick={handleDownloadClick}>
                    <FontAwesomeIcon icon={faDownload} />
                    <span>Download Template (Excel) </span>
                  </button>
                  <div className="form-group inputDnD">
                    <FontAwesomeIcon icon={faUpload} />
                    <input
                      type="file" className="form-control-file "
                      id="inputFile"
                      // accept=".xlsx, .xls, .csv"
                      onChange={handleFileChange}
                      data-title="Upload your file (Excel)" />

                    {/* {fileData && (
                                                <div>
                                                    <h4>File Data:</h4>
                                                    <pre>{fileData}</pre>
                                                </div>
                                            )} */}
                  </div>
                </div>

                {fileName && (
                  <div className='rafilname'>
                    <p>File Name: {fileName}</p>
                  </div>
                )}


                {/* <Form.Control
                                        type="file"
                                        onChange={handleFileChange}
                                        accept=".xlsx, .xls, .csv"
                                    /> */}
              </div>
            </>
          )}
          {modalContent === 'assetTypeChange' && (
            <>
              <h3>All Asset Type Changes</h3>
              <p>Are sure you want to change all asset type?</p>
              <div className='asset_midle'>
                <Form.Check
                  type='radio'
                  label='Owned'
                  name='assetType'
                  id='own'
                  value='O'
                  checked={modalRadioValue.assetType === 'O'}
                  onChange={handleModalRadioChange}
                />
                <Form.Check
                  type='radio'
                  label='Lease'
                  name='assetType'
                  id='lease'
                  value='L'
                  checked={modalRadioValue.assetType === 'L'}
                  onChange={handleModalRadioChange}
                />
              </div>
            </>
          )}
          {modalContent === 'cancelForm' && (
            <>
              <h3>Confirm Delete</h3>
              <p>If you proceed with the change, all data in this data will be removed.
                Are you sure you want to continue?</p>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          {modalContent === 'assetTypeChange' ?
            (
              <>
                <Button variant='primary' onClick={handleModalUpdate}>
                  Update Asset Type
                </Button>
              </>
            ) : (modalContent === 'import' ? (
              <>
                <div className='d-flex w-50 mx-auto are_bottom'>
                  <Button variant="secondary" onClick={() => handleConfirmation(false)}>
                    Cancel
                  </Button>
                  <Button variant="primary" onClick={handleUpload}>
                    Upload
                  </Button>
                </div>
              </>
            ) : (
              <>
                <div className='d-flex w-50 mx-auto are_bottom'>
                  <Button variant="secondary" onClick={() => handleConfirmation(false)}>
                    No
                  </Button>
                  <Button variant="primary" onClick={() => handleConfirmation(true)}>
                    Yes
                  </Button>
                </div>
              </>
            ))}
        </Modal.Footer>
      </Modal>
      <Modal show={mawbModal} onHide={closeModal} className='addfrom change_type add_shopment_frm_modal' centered size={modalFor == 'C' ? 'xl' : ''}>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          {modalFor == 'C' &&
            <>
              <h3>Add Shipment</h3>
              <Row className='mt-4'>
                <Col sm='6'>
                  <div className='missing_info modal_from '>
                    <h4>Shipment Information</h4>
                    <p></p>
                    <div className='top_part'>
                      <Form.Group as={Row} className="mb-2" controlId="exampleForm.ControlInput1">
                        <Col sm='6'>
                          <Form.Label>MAWB <span className='danger'>*</span></Form.Label>
                          <Form.Control type="text"
                            name='airway_bill'
                            value={formData.mawb || ''}
                            maxLength={13}
                            // maxLength='5' onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 5); }}
                            onChange={(e) => handleFormChange('mawb', e.target.value)}
                          />
                        </Col>
                        <Col sm="6">
                          <Form.Label>Special Handling Code</Form.Label>
                          <Select
                            options={handlingOptions}
                            onChange={(e) => handleFormChange("special_handling_code", e.value)}
                            placeholder="Select Handling Code"
                            className="autoslct w-100"
                            name="special_handling_code"
                            value={handlingOptions.find(option => option.value == formData.special_handling_code)}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} className="mb-2" controlId="cargoDetails">
                        <Col sm="6">
                          <Row className="align-items-end">
                            <Col sm="6">
                              <Form.Label>Exp Pieces <span className='danger'>*</span></Form.Label>
                              <Form.Control type="number" name='expected_pieces'  value={formData.expected_pieces || ''}  onChange={(e) => handleFormChange('expected_pieces', e.target.value)}/>
                            </Col>

                            <Col sm="6">
                              <Form.Group className="d-flex">
                                <Form.Check inline label="Colli" name="pcs_type" type="radio" id="colli" value="Colli" checked={formData.pcs_type == 'Colli'} onChange={e => handleFormChange('pcs_type', e.target.value)} />
                                <Form.Check inline label="ULD" name="pcs_type" type="radio" id="uld" value="ULD" checked={formData.pcs_type == 'ULD'} onChange={e => handleFormChange('pcs_type', e.target.value)} />
                              </Form.Group>
                            </Col>
                          </Row>
                        </Col>
                        <Col sm="6">
                          <Row>
                            <Col sm="6">
                              <Form.Label>Exp Weight</Form.Label>
                              <Form.Control type="number" name='expected_weight'  value={formData.expected_weight || ''}  onChange={(e) => handleFormChange('expected_weight', e.target.value)}/>
                            </Col>

                            <Col sm="6">
                              <Form.Label>Volume</Form.Label>
                              <Form.Control type="number" name='volume'  value={formData.volume || ''}  onChange={(e) => handleFormChange('volume', e.target.value)} />
                            </Col>
                          </Row>
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} className="mb-2" controlId="exampleForm.ControlInput1">
                        <Col sm='6'>
                          <Form.Label>Origin<span></span></Form.Label>
                          <Select
                            options={getDestination}
                            onChange={(e) => handleFormChange("origin", e.value)}
                            placeholder="Select Airport Origin"
                            className="autoslct w-100"
                            name="origin"
                            value={getDestination.find(
                            option => option.value === formData.flight_details[0].origin
                          )}
                          />
                        </Col>
                        <Col sm='6'>
                          <Form.Label>Destination<span></span></Form.Label>
                          <Select
                            options={getDestination}
                            onChange={(e) => handleFormChange("destination", e.value)}
                            placeholder="Select Airport Destination"
                            className="autoslct w-100"
                            name="destination"
                            value={getDestination.find(
                            option => option.value === formData.flight_details[0].destination
                          )}
                          />
                        </Col>
                      </Form.Group>
                    </div>
                    <div className='bottom_part'>
                      <Form.Group as={Row} className="mb-2" controlId="exampleForm.ControlInput1">
                        <Col sm='6'>
                          <Form.Label>Flight No</Form.Label>
                          <div className='d-flex'>
                            <Select
                              options={getOwnerCodes}
                              onChange={(e) => handleFormChange('flight_code', e.value)}
                              placeholder="flight"
                              className="autoslct pe-0"
                              name="flight_code"
                              value={getOwnerCodes.find(option => option.value === formData?.flight_details[0]?.flight_code) || ''}
                            />
                            <Form.Control type="text" className='fl_wd' placeholder="" value={formData?.flight_details[0]?.flight_number}
                              onChange={(e) => handleFormChange('flight_number', e.target.value)} />
                          </div>
                        </Col>
                        <Col sm='6'>
                          <Form.Label>Flight Date<span></span></Form.Label>
                          <Form.Control type="date"
                            name='flight_date'
                            value={formData.flight_details[0].flight_date}
                            onChange={(e) => handleFormChange('flight_date', e.target.value)}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} className="mb-2" controlId="exampleForm.ControlInput1">
                        <Col sm='6'>
                          <Form.Label>ETA </Form.Label>
                          <Form.Control type="datetime-local"
                            name='eta'
                             value={formData.flight_details[0].eta}
                            onChange={(e) => handleFormChange('eta', e.target.value)}
                          />
                        </Col>
                      </Form.Group>
                    </div>
                    <div className='bottom_part'>
                     <Form.Group as={Row} className="mb-2" controlId="exampleForm.ControlInput1">
                        <Col sm="6">
                          <Form.Label>Shipper</Form.Label>
                          <span className='d-inline-flex w-100 me-0'>
                            <CreatableSelect
                              options={shipperOptions} className="autoslct w-100" placeholder="Shipper" isClearable formatCreateLabel={(inputValue) => `+ Add "${inputValue}"`}
                              value={
                                formData?.shipper_id 
                                  ? shipperOptions.find(option => option.value === formData.shipper_id)
                                  : formData?.shipper 
                                  ? { label: formData.shipper, value: formData.shipper, __isNew__: true }
                                  : null
                              }
                              onChange={(option) => {
                                if (!option) {
                                  handleFormChange("shipper_id", null);
                                  handleFormChange("shipper", null);
                                  return;
                                }
                                if (option.__isNew__) {
                                  handleFormChange("shipper", option.value);
                                  handleFormChange("shipper_id", null);
                                } else {
                                  handleFormChange("shipper_id", option.value);
                                  handleFormChange("shipper", null);
                                }
                              }}
                            />
                            <Button className='flex-grow-1 ms-2 customer_icon' onClick={() => handleCustomerModal('shipper')}>
                              <FontAwesomeIcon icon={faUser} />
                            </Button>
                          </span>
                        </Col>

                        <Col sm="6">
                          <Form.Label>Consignee</Form.Label>
                          <span className='d-inline-flex w-100 me-0'>
                            <CreatableSelect
                              options={consigneeOptions} placeholder="Consignee" className="autoslct w-100" isClearable formatCreateLabel={(inputValue) => `+ Add "${inputValue}"`}
                              value={
                                formData?.consignee_id 
                                  ? consigneeOptions.find(option => option.value === formData.consignee_id)
                                  : formData?.consignee 
                                  ? { label: formData.consignee, value: formData.consignee, __isNew__: true }
                                  : null
                              }
                              onChange={(option) => {
                                if (!option) {
                                  handleFormChange("consignee_id", null);
                                  handleFormChange("consignee", null);
                                  return;
                                }

                                if (option.__isNew__) {
                                  handleFormChange("consignee", option.value);
                                  handleFormChange("consignee_id", null);
                                } else {
                                  handleFormChange("consignee_id", option.value);
                                  handleFormChange("consignee", null);
                                }
                              }}
                            />
                            <Button className='flex-grow-1 ms-2 customer_icon' onClick={() => handleCustomerModal('consignee')}>
                              <FontAwesomeIcon icon={faUser} />
                            </Button>
                          </span>
                        </Col>
                      </Form.Group>
                    </div>
                  </div>
                  {/* <div className='missing_info modal_from'>
                    <h4>House AWB's</h4>
                    <p></p>

                    <div className='expcet_hawb'>
                      {savedHouseAwbs.map((item, idx) => (
                        <div key={idx} className='hawb_box'>
                          <div className='d-flex justify-content-between align-items-center'>
                            <div> <h3>{item.hawb_no}</h3> </div>
                            <div>
                              <Button variant="link" onClick={() => handleEditHawb(idx)}> <img src={Edit} /></Button>
                              <Button variant="link" onClick={() => handleDeleteHawb(idx)}> <img src={Trash} /></Button>
                            </div>
                          </div>
                          <div>
                            {item.packing_groups.map((g, gidx) => (
                              <div key={gidx}>
                                <h4>{g.packaging}</h4>
                                <div>
                                  <span>Pieces: {g.e_pcs}</span> <span> Weight: {g.e_weight}</span>
                                </div>
                                <ul>
                                  <li></li>
                                  <li></li>
                                </ul>
                              </div>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div> */}
                </Col>
                <Col sm='6'>
                  <div className='missing_info modal_from h-100'>
                    <div className="d-flex justify-content-between align-items-center mb-0">
                      <h4>House AWB's Information</h4>
                      <Button variant="link" className="p-0 text-decoration-none fw-bold" onClick={() => setHawbShow(true)}>+ Add HAWB</Button>
                    </div>
                     <hr/>
                    {hawbShow && (
                      <div className="hawb-input-section mb-3">
                        <Form.Group className="mb-2">
                          <Form.Label>HAWB <span className='danger'>*</span></Form.Label>
                          <Form.Control type="text"
                            name='hawb_no'
                            value={houseAwbInput}
                            onChange={e => setHouseAwbInput(e.target.value)}
                            maxLength={13}
                          />
                        </Form.Group>

                        {shipmentGroups.map((group, idx) => (
                          <Form.Group as={Row} className="mb-2" key={idx}>
                            <Col sm='6'>
                              <Form.Label>Expected Pieces</Form.Label>
                              <Form.Control
                                type="number"
                                min={1}
                                value={group.e_pcs}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (value === '' || Number(value) >= 1)
                                    handleGroupChange(idx, 'e_pcs', e.target.value)
                                }}
                              />
                            </Col>
                            <Col sm='6'>
                              <Form.Label>Expected Weight</Form.Label>
                              <Form.Control
                                type="number"
                                min={1}
                                value={group.e_weight}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (value === '' || Number(value) >= 1)
                                    handleGroupChange(idx, 'e_weight', e.target.value)
                                }}
                              />
                            </Col>
                          </Form.Group>
                        ))}

                        <div className="d-flex gap-2 mt-2">
                          <Button
                            variant="secondary"
                            className="flex-fill"
                            onClick={handleCancelHawb}
                          >
                            Cancel
                          </Button>
                          <Button
                            variant="primary"
                            className="flex-fill"
                            onClick={handleSaveHawb}
                          >
                            {editIndex !== null ? 'Update Hawb' : 'Save Hawb'}
                          </Button>
                        </div>
                      </div>
                    )}

                    <div className='expcet_hawb mt-3'>
                      {savedHouseAwbs.map((item, idx) => (
                        <div key={idx} className='hawb_box card mb-2 border-0'>
                          <div className='d-flex justify-content-between align-items-start'>
                            <div>
                              <h6 className="text-secondary mb-1">HAWB - {item.hawb_no}</h6>
                              {item.packing_groups.map((g, gidx) => (
                                <p key={gidx} className="text-muted">
                                  <span>Pieces : {g.e_pcs}</span> <span className="ms-3">Weight : {g.e_weight}</span>
                                </p>
                              ))}
                            </div>
                            <div className='d-flex align-items-center gap-2'>
                              <Button variant="link" className="p-0" onClick={() => handleEditHawb(idx)}>
                                <img src={Edit} alt="Edit" style={{ width: '16px' }} />
                              </Button>
                              <Button variant="link" className="p-0 text-danger" onClick={() => handleDeleteHawb(idx)}>
                                <img src={Trash} alt="Delete" style={{ width: '16px' }} />
                              </Button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </Col>
              </Row>
            </>
          }
          {modalFor == 'B' &&
            <>
              <h3>Move In Stock</h3>

              <div className='modal_from'>
                <h5>MAWB: {modalData.mawb}</h5>
                {/* <p></p> */}
                <Accordion defaultActiveKey="0" flush>
                  {shipmentGroups.map((group, idx) => (
                    <Accordion.Item eventKey={idx.toString()} key={idx}>
                      <Accordion.Header>HAWB: {group.hawb}</Accordion.Header>
                      <Accordion.Body>
                        {/* <Form.Group className="mb-2">
                          <Form.Label>Packaging<span className="text-danger">*</span></Form.Label>
                          <Form.Select
                            value={group.packaging}
                            onChange={e => handleGroupChange(idx, 'packaging', e.target.value)}
                            disabled={true}
                          >
                            <option value="">Select Packaging</option>
                            {getPackaging?.map(pack =>
                              <option value={pack.value}>{pack.label}</option>
                            )}
                          </Form.Select>
                        </Form.Group> */}

                        <Form.Group as={Row} className="mb-2">
                          <Col sm='6'>
                            <Form.Label>Expected Pieces<span className="text-danger">*</span></Form.Label>
                            <Form.Control
                              type="text"
                              value={group.e_pcs}
                              onChange={e => handleGroupChange(idx, 'e_pcs', e.target.value)}
                              disabled={true}
                            />
                          </Col>
                          <Col sm='6'>
                            <Form.Label>Expected Weight<span></span></Form.Label>
                            <Form.Control
                              type="text"
                              max={group.a_pcs}
                              value={group.e_weight}
                              onChange={e => handleGroupChange(idx, 'e_weight', e.target.value)}
                              disabled={true}
                            />
                          </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-2">
                          <Form.Label column sm="12">
                            Pieces confirm? <span className="text-danger">*</span>
                          </Form.Label>
                          <Col sm="12">
                            <Form.Check
                              type="radio"
                              label="YES"
                              name={`piecesConfirm-${idx}`}
                              id={`piecesConfirmYes-${idx}`}
                              value="YES"
                              checked={group.piecesConfirm == 'YES'}
                              onChange={e => {
                                handleGroupChange(idx, 'piecesConfirm', e.target.value);
                                if (e.target.value === 'YES') {
                                  handleGroupChange(idx, 'a_pcs', group.e_pcs);
                                  handleGroupChange(idx, 'a_weight', group.e_weight);
                                }
                              }}
                              inline
                            />
                            <Form.Check
                              type="radio"
                              label="NO"
                              name={`piecesConfirm-${idx}`}
                              id={`piecesConfirmNo-${idx}`}
                              value="NO"
                              checked={group.piecesConfirm == 'NO'}
                              onChange={e => { handleGroupChange(idx, 'piecesConfirm', e.target.value); handleGroupChange(idx, 'a_pcs', ''); handleGroupChange(idx, 'a_weight', ''); }}
                              inline
                            />
                          </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-2">
                          <Col sm='6'>
                            <Form.Label>Accepted Pieces<span className="text-danger">*</span></Form.Label>
                            <Form.Control
                              type="number"
                              value={group.a_pcs}
                              onChange={e => handleGroupChange(idx, 'a_pcs', e.target.value)}
                              disabled={group.piecesConfirm === 'YES'}
                            />
                          </Col>
                          <Col sm='6'>
                            <Form.Label>Accepted Weight<span></span></Form.Label>
                            <Form.Control
                              type="number"
                              value={group.a_weight}
                              onChange={e => handleGroupChange(idx, 'a_weight', e.target.value)}
                              disabled={group.piecesConfirm === 'YES'}
                            />
                          </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-2">
                          <Col sm='6'>
                            <Form.Label>Location<span></span></Form.Label>
                            <Select
                              options={locationOptions}
                              onChange={(selected) => {
                                handleGroupChange(idx,
                                  "location",
                                  selected ? selected.value : ""
                                );
                              }}
                              placeholder="Location" className="rfs_autoslct" name="location"
                              value={
                                locationOptions.find(
                                  (option) => option.value === shipmentGroups[idx].location
                                ) || null
                              }
                            />
                          </Col>
                          {switchData && (<>
                            <Col sm="3" className='pe-0'>
                              <Form.Label>
                                Temperature<span><span className="text-danger">*</span></span>
                              </Form.Label>
                              <Form.Control
                                type="number"
                                value={group.temparature}
                                onChange={e =>
                                  handleGroupChange(idx, "temparature", e.target.value)
                                }
                              // disabled={true}
                              /></Col>
                            <Col sm="3">
                              <Form.Label>
                                Temp Type<span><span className="text-danger">*</span></span>
                              </Form.Label>
                              <Select
                                options={TemperatureOptions}
                                onChange={(e) => handleGroupChange(idx, "temperature_type", e.value)}
                                value={TemperatureOptions.find(opt => opt.value === group.temperature_type) || ''}
                                className="w-100"
                              // placeholder="--"
                              //isDisabled={false}
                              />
                            </Col></>
                          )}

                        </Form.Group>
                        <Form.Group as={Row} className="mb-2">
                          <Col sm='12'>
                            <Form.Label>Warehouse In :  {switchData && <span className="text-danger">*</span>}</Form.Label>
                            <Form.Control
                              type="datetime-local"
                              value={group.warehouse_in}
                              onChange={e => handleGroupChange(idx, 'warehouse_in', e.target.value)}
                            // disabled={true}
                            />
                          </Col>
                        </Form.Group>
                        {group.warehouse_in_doc_type === 'Transfer' && (
                          <>
                            <Form.Group as={Row} className="mb-2">
                              <Col sm="12">
                                <Form.Label>
                                  Doc Type : {switchData && <span className="text-danger">*</span>}
                                </Form.Label>
                                <Select
                                  options={acceptanceWarehouseInhandlerOptions}
                                  name="warehouse_in_doc_type"
                                  className="w-100 autoslct"
                                  value={
                                    acceptanceWarehouseInhandlerOptions.find(
                                      opt => opt.value === group.warehouse_in_doc_type
                                    ) || ''
                                  }
                                  onChange={e =>
                                    handleGroupChange(idx, 'warehouse_in_doc_type', e.value)
                                  }
                                />
                              </Col>
                            </Form.Group>
                          </>
                        )}
                        {group.warehouse_in_doc_type != 'Transfer' && (
                          <Form.Group as={Row} className="mb-2">
                            <Col sm='6'>
                              <Form.Label>Doc Type : {switchData && <span className="text-danger">*</span>}</Form.Label>
                              {/* <Form.Control
                              type="text"
                              value={group.warehouse_in_doc_type}
                              onChange={e => handleGroupChange(idx, 'warehouse_in_doc_type', e.target.value)}
                              //disabled={true}
                            /> */}
                              <Select
                                options={acceptanceWarehouseInhandlerOptions}
                                name="warehouse_in_doc_type"
                                className="w-100 autoslct"
                                value={acceptanceWarehouseInhandlerOptions.find(opt => opt.value === group.warehouse_in_doc_type) || ''}
                                onChange={(e) => handleGroupChange(idx, 'warehouse_in_doc_type', e.value)}
                              />
                            </Col>
                            <Col sm='6'>
                              <Form.Label>DOC No : {switchData && <span className="text-danger">*</span>}</Form.Label>
                              <Form.Control
                                type="text"
                                value={group.warehouse_in_doc_no}
                                onChange={e => handleGroupChange(idx, 'warehouse_in_doc_no', e.target.value)}
                              //disabled={true}
                              />
                            </Col>
                          </Form.Group>)}
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>

              </div>
            </>
          }
        </Modal.Body>
        <Modal.Footer>
          <div className='d-flex w-50 mx-auto are_bottom'>
            <Button variant="secondary" onClick={closeModal}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleCheckSubmit}>
              Submit
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal show={confirmModal} onHide={confirmModalClose} className='raintrac' centered>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <h2>Accepted Pieces Exceed's Expected Quantity</h2>
          <p>
            The number of accepted pieces is greater than the expected pieces.
            Are you sure you want to continue?
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setConfirmModal(false)}>
            No
          </Button>
          <Button variant="primary" onClick={() => { handleConfirmation(true) }}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={modalOpen} onHide={modalClose} className='addfrom change_type' centered>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <h3>Set {modalData.updateFlag == 'ETA' ? 'ETA' : modalData.updateFlag == 'RCF' ? 'RCF' : modalData.updateFlag == 'ATA' ? 'ATA' : modalData.updateFlag == 'DLV' ? 'DLV' : 'NOA'}</h3>
          <div className='saairbill'>
            <Form.Label>Date & Time<span>*</span></Form.Label>
            <Form.Control
              type="datetime-local" name='set_date'
              value={modalData.set_date || getCurrentDateTime()}
              onChange={(e) => modalInputChange('set_date', e.target.value)}
            />
          </div>

        </Modal.Body>
        <Modal.Footer>
          {/* <Button variant="danger" disabled={isSaving} className='position-relative' onClick={isModalClose}>
                              Cancel
                            </Button> */}
          <Button variant="primary" className='position-relative' onClick={updateDate}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal className='raintrac' show={showConfirmation} onHide={() => setShowConfirmation(false)}>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <h2>{`Selected ${gridSelect.length > 1 ? "Shipment's" : 'Shipment'} will move to ${activeTab == 'Active' ? 'Archive' : 'Active'}`}</h2>
          <p>If you proceed with the change, user data will be {`moved to ${activeTab == 'Active' ? 'Archive' : 'Active'}`}.
            Are you sure you want to continue?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConfirmation(false)}>
            No
          </Button>
          <Button variant="primary" onClick={confirmMoveToActArc}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
        <Modal show={customerModal} centered onHide={hideCustomerModal} className='addfrom' >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Add {customerModalType === 'shipper' ? 'Shipper' : 'Consignee'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group as={Row} className='mb-2'>
                        <Col sm="12">
                            <Form.Label>Customer Name <span>*</span></Form.Label>
                            <Form.Control type="text" name='name' placeholder="Add Name" value={customerData.name} onChange={(e) => handleCustomerChange('name', e.target.value)} />
                        </Col>
                    </Form.Group>
                    {!isModal &&
                        <Form.Group as={Row} className='mb-2'>
                            <Col sm="12">
                                <Form.Label>Customer/Agent <span>*</span></Form.Label>
                                <Select
                                    options={CustomerOrAgent}
                                    onChange={(selected) => {
                                        handleCustomerChange('agent_or_customer', selected ? selected.value : '');
                                    }}
                                    placeholder="Customer"
                                    className='rfs_autoslct'
                                    name="agent_or_customer"
                                    value={CustomerOrAgent.find(option => option.value === customerData.agent_or_customer) || null}
                                />
                            </Col>
                        </Form.Group>
                    }
                    <Form.Group as={Row} className='mb-2'>
                        <Col sm="12">
                            <Form.Label>Customer Type <span>*</span></Form.Label>
                            <Select
                                options={CustomerOptions}
                                onChange={(selected) => {
                                    handleCustomerChange('customer_type', selected ? selected.value : '');
                                }}
                                placeholder="Customer"
                                className='rfs_autoslct'
                                name="customer_type"
                                value={CustomerOptions.find(option => option.value === customerData.customer_type) || null}
                            />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className='mb-2'>
                        <Col sm="6">
                            <Form.Label>Agent Code {customerData.customer_type === 'F' && <span>*</span>}</Form.Label>
                            <Form.Control type="text" name='agent_code' placeholder="Add Agent Code" value={customerData.agent_code} onChange={(e) => handleCustomerChange('agent_code', e.target.value)} />
                        </Col>
                        <Col sm="6">
                            <Form.Label>Email</Form.Label>
                            <Form.Control type="text" name='email' placeholder="Add Email" value={customerData.email} onChange={(e) => handleCustomerChange('email', e.target.value)} />
                        </Col>
                    </Form.Group>
                    <div className="mb-1 d-flex justify-content-end">
                      <span style={{ cursor: 'pointer', color: '#0d6efd', fontWeight: 500 }} onClick={() => setShowMore(!showMore)}>
                        {showMore ? '- Show less' : '+ Add more'}
                      </span>
                    </div>
                   <Collapse in={showMore}>
                    <div>
                      <Form.Group as={Row} className="mb-2">
                        <Col sm="12">
                          <Form.Label>Account Number</Form.Label>
                          <Form.Control
                            type="text" placeholder="Add Account no." value={customerData.account_number}
                            onChange={(e) => handleCustomerChange('account_number', e.target.value)}/>
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} className="mb-2">
                        <Col sm="12">
                          <Form.Label>Vat Nr</Form.Label>
                          <Form.Control
                            type="text" placeholder="Vat Number" value={customerData.vat_nr}
                            onChange={(e) => handleCustomerChange('vat_nr', e.target.value)}
                          />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} className="mb-2">
                        <Col sm="12">
                          <Form.Label>Address</Form.Label>
                          <Form.Control
                            type="text" placeholder="Add Address" value={customerData.street_name}
                            onChange={(e) => handleCustomerChange('street_name', e.target.value)}
                          />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} className="mb-2">
                        <Col sm="6">
                          <Form.Label>Postal Code</Form.Label>
                          <Form.Control
                            type="text" placeholder="Add Postal Code" value={customerData.postal_code}
                            onChange={(e) => handleCustomerChange('postal_code', e.target.value)}
                          />
                        </Col>
                        <Col sm="6">
                          <Form.Label>City</Form.Label>
                          <Form.Control
                            type="text" placeholder="Add City" value={customerData.city}
                            onChange={(e) => handleCustomerChange('city', e.target.value)}
                          />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} className="mb-2">
                        <Col sm="12">
                          <Form.Label>Country</Form.Label>
                          <Form.Control
                            type="text" placeholder="Add Country" value={customerData.country}
                            onChange={(e) =>handleCustomerChange('country', e.target.value)}
                          />
                        </Col>
                      </Form.Group>
                    </div>
                  </Collapse>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="secondary" onClick={hideCustomerModal}>
                            Discard
                        </Button>
                        <Button variant="primary" onClick={handleCustomerSave}>
                            Save
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
    </>
  )
}

export default Expected